import {Action} from '@reduxjs/toolkit'
import moment from 'moment'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[Dashboard SetFilter] Action',
  ResetFilter: '[Dashboard ResetFilter] Action',
}

const initialDashboardState: IDashboardState = {
  filter: {
    tenantId: '',
    tenantName: '',
  },
}

export interface IDashboardState {
  filter?: {
    tenantId: string
    tenantName: string
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-Dashboard', whitelist: ['filter']},
  (state: IDashboardState = initialDashboardState, action: ActionWithPayload<IDashboardState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialDashboardState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
